import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgTrending = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.475 2c-.234 0-.465.062-.668.181a1.118 1.118 0 0 0-.35 1.517c.83 1.41 1.324 3.064 1.335 4.605.01 1.285-.314 2.454-1.017 3.361a7.1 7.1 0 0 1-1.441-2.09.75.75 0 0 0-1.043-.35 6.33 6.33 0 0 0-2.446 2.367 6.2 6.2 0 0 0-.843 3.278v.011a7.3 7.3 0 0 0 .714 2.86 7.4 7.4 0 0 0 1.789 2.36 7.6 7.6 0 0 0 2.577 1.491c.944.321 1.942.455 2.938.395 2.478-.005 4.44-.765 5.807-2.07 1.37-1.307 2.077-3.097 2.164-5.033.204-4.603-3.093-10.087-8.888-12.725A1.3 1.3 0 0 0 10.475 2m1.817 6.292c-.01-1.48-.392-3.009-1.036-4.39 4.829 2.536 7.4 7.209 7.237 10.914-.073 1.612-.654 3.015-1.702 4.015-1.044.996-2.617 1.655-4.794 1.655q-.024 0-.048.002a6.2 6.2 0 0 1-2.384-.317 6.1 6.1 0 0 1-2.068-1.196 5.9 5.9 0 0 1-1.428-1.883 5.8 5.8 0 0 1-.568-2.268 4.7 4.7 0 0 1 .64-2.477 4.8 4.8 0 0 1 1.22-1.385A8.6 8.6 0 0 0 9.348 13.3a.75.75 0 0 0 .988-.031c1.409-1.314 1.971-3.135 1.957-4.977m4.077 6.557a.75.75 0 0 0-1.5 0 2.06 2.06 0 0 1-.623 1.472 2.18 2.18 0 0 1-1.525.617.75.75 0 0 0 0 1.5 3.68 3.68 0 0 0 2.574-1.046 3.56 3.56 0 0 0 1.074-2.543"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgTrending;
